"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.trackPageView = exports.trackImpression = exports.trackEvent = exports.trackClick = exports.MessageType = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Generic key-value payload object.
 */

/**
 * A typed payload.
 */

/**
 * Available message types.
 */
var MessageType;
/**
 * Legacy Message format for use with `__fa.push(...)`.
 *
 * @see push
 */

exports.MessageType = MessageType;

(function (MessageType) {
  MessageType["Click"] = "click";
  MessageType["Event"] = "event";
  MessageType["PageView"] = "pageview";
  MessageType["Impression"] = "impression";
})(MessageType || (exports.MessageType = MessageType = {}));

/**
 * Send a message to the backend. This method prefer `navigator.sendBeacon`
 * if supported, but will fallback to requesting a pixel image.
 */
var log = function log(message) {
  // Default `ref_path` value to the current pathname
  // if not explicitly set.
  if (typeof message.ref_path === 'undefined') {
    message.ref_path = window.location.pathname;
  }

  var query = Object.keys(message).reduce(function (acc, key) {
    acc.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(message[key]))));
    return acc;
  }, []).join('&');
  var url = "/ablincoln/fatal_attraction?".concat(query);

  if (typeof navigator.sendBeacon === 'function') {
    navigator.sendBeacon(url);
    return;
  }

  var img = new Image();
  img.src = url;
};
/**
 * Track a legacy message by using the type specified in the first position of
 * the message array.
 *
 * @deprecated
 */


var push = function push(message) {
  if (!Array.isArray(message) || typeof message[0] !== 'string') {
    return;
  }

  switch (message[0]) {
    case 'trackEvent':
      trackEvent(message[1]);
      break;

    case 'trackPageview':
      trackPageView();
      break;
  }
};
/**
 * Log a click message.
 */


var trackClick = function trackClick(payload) {
  log(_objectSpread({}, payload, {
    type: MessageType.Click
  }));
};
/**
 * Log an event message.
 */


exports.trackClick = trackClick;

var trackEvent = function trackEvent(payload) {
  log(_objectSpread({}, payload, {
    type: MessageType.Event
  }));
};
/**
 * Log an impression message.
 */


exports.trackEvent = trackEvent;

var trackImpression = function trackImpression(payload) {
  log(_objectSpread({}, payload, {
    type: MessageType.Impression
  }));
};
/**
 * Parse the query string for the current page.
 */


exports.trackImpression = trackImpression;

var parseQueryString = function parseQueryString() {
  var queryString = window.location.search;

  if (!queryString) {
    return {};
  }

  var paramStrings = queryString.slice(1).split('&');
  var params = paramStrings.reduce(function (acc, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    acc[key] = value;
    return acc;
  }, {});
  return params;
};
/**
 * Log a pageview message.
 */


var trackPageView = function trackPageView() {
  var qs = parseQueryString();
  var message = {
    type: MessageType.PageView,
    target: window.location.pathname + window.location.search
  };

  if (qs.vcid) {
    message.vcid = qs.vcid;
  }

  if (qs.referrer_vuid) {
    message.referrer_vuid = qs.referrer_vuid;
  }

  log(message);
};
/**
 * Dispatch all messages in the provided queue and overwrite the array's `push`
 * method to proxy any legacy messages.
 */


exports.trackPageView = trackPageView;

var init = function init() {
  var queue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  queue.forEach(push);

  queue.push = function () {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Pushing directly to window.__fa will be deprecated. Please use the @vpr/tracking module instead.');
    }

    for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
      messages[_key] = arguments[_key];
    }

    messages.forEach(push); // The legacy array's length never changed after initialization.

    return queue.length;
  };
};

exports.init = init;